module.exports = __webpack_public_path__ + "static/media/mesotherapy.51e9cc79.svg";